import React from 'react';

import "./styles.css";


const AppCheckbox = ({label}) => {
  return (
    <label className="checkbox__container">
      <input type="checkbox" />
      <span className="checkmark"></span>
      <span className="checkbox--label">{label}</span>
    </label>
  )
}

export default AppCheckbox;